<template>
  <div
    style="position: relative; height: 100%;">
    <base-widget-header
      ref="widgetHeader" :label="labels.title" :loading="isLoading"
      class="widget widgetText--text pa-0" @close-parent-widget="close" />
    <v-row>
      <v-col cols="12" class="py-0">
        <v-divider />
      </v-col>
    </v-row>
    <v-container style="overflow-y: auto; height: calc(100% - 72px - 100px); overflow-x: hidden">
      <v-row align="center" align-content="center">
        <v-col style="font-weight: 100;" class="text-center">
          <v-icon class="custom-icon-size">
            {{ customTool.icon }}
          </v-icon>
        </v-col>
      </v-row>
      <v-row align-content="center">
        <v-col class="text-center" style="font-weight: 100;">
          <span :style="{fontSize: '16px', opacity: '0.6', fontWeight: '400'}">
            {{ labels.importData }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-file-input
          ref="fileInput" v-model="file" :label="labels.info"
          variant="solo-filled"
          accept=".zip"
          :error-messages="errorMessageInputFile"
          @change="checkFile" />
      </v-row>
      <v-row>
        <v-col cols="12" class="py-0">
          <p>{{ labels.templateDownload }}</p>
          <v-divider />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="py-0 px-10" :style="{fontSize: '14px'}">
          <p> {{ labels.locations }} </p>
          <v-row class="py-0 px-10">
            <v-list>
              <v-row>
                <a href="https://gis.ratel.rs/docs/shp/Lokacije/poslovnice.zip" target="blank" download="poslovnice.zip">
                  {{ labels.businessLocations }}
                </a>
              </v-row>
              <v-row>
                <a href="https://gis.ratel.rs/docs/shp/Lokacije/paketomati.zip" target="blank" download="paketomati.zip">
                  {{ labels.parcelLockers }}
                </a>
              </v-row>
              <v-row>
                <a href="https://gis.ratel.rs/docs/shp/Lokacije/sanducici.zip" target="blank" download="sanducici.zip">
                  {{ labels.postBoxes }}
                </a>
              </v-row>
            </v-list>
          </v-row>
        </v-col>
      </v-row>
      <v-col cols="12" class="py-4" />
      <v-row>
        <v-col cols="12" class="py-0 px-10" :style="{fontSize: '14px'}">
          <p> {{ labels.services }} </p>
          <v-row class="py-0 px-10">
            <v-list>
              <v-row>
                <a href="https://gis.ratel.rs/docs/shp/postUsluge/postUslugeIstiDan.zip" target="blank" download="postUslugeIstiDan.zip">
                  {{ labels.sameDayExpress }}
                </a>
              </v-row>
              <v-row>
                <a href="https://gis.ratel.rs/docs/shp/postUsluge/postUslugeNaredniOdredjeniDan.zip" target="blank" download="postUslugeNaredniOredjeniDan.zip">
                  {{ labels.nextDayExpress }}
                </a>
              </v-row>
              <v-row>
                <a href="https://gis.ratel.rs/docs/shp/postUsluge/postUslugeKurirske.zip" target="blank" download="postUslugeKurirske.zip">
                  {{ labels.courierServices }}
                </a>
              </v-row>
              <v-row>
                <a href="https://gis.ratel.rs/docs/shp/postUsluge/postUslugeUniverzalnaPostUsluga.zip" target="blank" download="postUslugeUniverzalnaPostUsluga.zip">
                  {{ labels.universalPostalService }}
                </a>
              </v-row>
            </v-list>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div
      ref="footerDiv"
      style="position: absolute; bottom: 0px; overflow: hidden; width: 100%; height: 100px"
      class="pt-2 pb-2">
      <v-row>
        <v-col class="pb-2">
          <v-divider />
        </v-col>
      </v-row>
      <v-row
        align="center"
        align-content="center"
        justify="center"
        class="px-5 pb-1">
        <v-col align-self="center" cols="12" class="pb-2">
          <BasePrimaryBtn :title="labels.importData" :disabled="enableImport" @click="importData" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import customJson from '@/customTools/geoprocessingTool.json'
import * as urlUtils from '@arcgis/core/core/urlUtils'
import esriRequest from '@arcgis/core/request'
import * as geoprocessor from '@arcgis/core/rest/geoprocessor'

export default {
  name: 'GeoprosessingTool',
  data () {
    return {
      isLoading: false,
      customTool: null,
      file: null,
    }
  },
  computed: {
    labels () {
      return customJson.labels[this.$store.getters.getLanguage]
    },
    url () {
      return process.env.VUE_APP_REST_URL
    },
    errorMessageInputFile () {
      return this.file && !this.checkFile() ? this.labels.errorZip : ''
    },
    enableImport () {
      return !this.checkFile()
    },
  },
  created () {
    const customTools = this.$store.getters.getConfigJson.customTools
    this.customTool = customTools.find(item => item.id === 'GeoprocessingTool')
  },
  methods: {
    close () {
      this.$store.dispatch('unSetActiveTool')
    },
    checkFile () {
      if (!this.file) return false
      const fileName = this.file.name
      const fileExtension = fileName?.split('.').pop()?.toLowerCase()
      return fileExtension === 'zip'
    },
    setProxy () {
      urlUtils.addProxyRule({
        urlPrefix: customJson.config.gpUrl,
        proxyUrl: customJson.config.proxy,
      })

      urlUtils.addProxyRule({
        urlPrefix: customJson.config.uploadTaskUrl,
        proxyUrl: customJson.config.proxy,
      })
    },
    importData () {
      this.setProxy()
      this.uploadFileForGP()
    },
    uploadFileForGP () {
      this.isLoading = true
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('f', 'json')
      esriRequest(customJson.config.uploadTaskUrl, {
        body: formData,
        responseType: 'json',
        useProxy: customJson.config.useProxy,
      }).then((response) => {
        this.executeGPService(response)
        this.isLoading = false
      }).catch((error) => {
        console.log('Error: ', error)
        this.$store.dispatch('showSnackbar', { color: 'error', customText: 'error', hideBtn: true, timeout: 2000 })
        this.isLoading = false
      })
    },
    executeGPService (response, io) {
      const itemID = response.data.item.itemID
      console.log('response: ', response, 'itemID ', itemID)
      const inputParams = {
        Input_ZIP: '{"itemID":"' + itemID + '"}',
        Username: this.$store.getters.getLoggedInUser.username, // + 'jppostasr'
      }
      geoprocessor.submitJob(customJson.config.gpUrl, inputParams).then((jobInfo) => {
        const options = {
          interval: 1500,
          statusCallback: (j) => {
            console.log(j.jobStatus)
          },
        }
        jobInfo.waitForJobCompletion(options).then((result) => {
          this.loading = false
          if (jobInfo.jobStatus === 'job-succeeded') {
            this.$store.dispatch('showSnackbar', { color: 'success', customText: this.labels.successData, hideBtn: true, timeout: 2000 })
            this.resetTool()
          } else {
            this.$store.dispatch('showSnackbar', { color: 'error', customText: this.labels.errorData, hideBtn: true, timeout: 2000 })
          }
        })
      })
    },
  },
  uploadFailed () {
    this.$store.dispatch('showSnackbar', { color: 'error', customText: 'error', hideBtn: true, timeout: 2000 })
  },
  resetTool () {
    this.file = null
  },
}
</script>

<style scoped>
.custom-icon-size {
  font-size: 5rem;
}
</style>
